import type { WorkshopNavItem } from '../../workshop/workshopNavTypes';

/**
 * Project Analytics & Accounting Suite — entries of the "Reporting" menu, shared by the
 * desktop top-nav dropdown (OdooTopNav) and the mobile drawer (OdooShellMobileNav).
 * Route for each item is `/{resource}` inside the Project Management workspace, matching
 * the Auto Workshop reports convention.
 */
export const PROJECT_REPORTS_NAV: WorkshopNavItem[] = [
    { resource: 'projectAnalyticsReport', label: 'Project Analytics Dashboard' },
    { resource: 'projectGanttReport', label: 'Project Gantt / Timeline' },
    { resource: 'projectLedgerReport', label: 'Project Financial Ledger' },
    { resource: 'projectDayBookReport', label: 'Day Book' },
    { resource: 'projectTimeSheetReport', label: 'Time Sheet' },
];

/**
 * Extra Reporting entry shown only when the Purchases app is installed for the tenant:
 * the Purchase Register (same screen the Purchases workspace mounts). The nav components
 * append it after checking the tenant-install + purchases.purchaseRegisterReport gates,
 * so it is deliberately NOT part of PROJECT_REPORTS_NAV.
 */
export const PM_PURCHASE_REGISTER_NAV: WorkshopNavItem = {
    resource: 'purchaseRegisterReport',
    label: 'Purchase Register',
};
